import "./i18n";
import "./main.css";
// Import as raw string to bypass PostCSS: velaro-component-lib ships Tailwind v4
// CSS (@layer base) which Tailwind v3.4+ cannot process on Windows.
import compLibCss from "@velaro/velaro-component-lib/dist/velaro-component-lib.css?raw";
const _compLibStyle = document.createElement("style");
_compLibStyle.dataset.source = "velaro-component-lib";
_compLibStyle.textContent = compLibCss;
document.head.appendChild(_compLibStyle);

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
import { reportErrorToSupport } from "./components/GlobalErrorBoundary";
import { CircuitOpenError } from "./services/RestService";
import { loadClientConfig } from "./services/clientConfig";

// Catch JS errors that happen outside the React render tree (event handlers,
// setTimeout callbacks, etc.)
window.onerror = (message, source, lineno, colno, error) => {
  reportErrorToSupport({
    message: String(message),
    stack: error?.stack ?? `${source}:${lineno}:${colno}`,
    componentStack: "",
    url: window.location.href,
    userAgent: navigator.userAgent,
    timestamp: new Date().toISOString(),
    type: "async"
  });
  // Return false so the default browser error handling still runs
  return false;
};

// Catch unhandled Promise rejections (e.g. await inside useEffect with no catch)
window.addEventListener("unhandledrejection", (event) => {
  // Circuit-open errors are intentional fast-fails, not crashes — suppress them
  if (event.reason instanceof CircuitOpenError) return;

  const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
  reportErrorToSupport({
    message: error.message ?? "Unhandled promise rejection",
    stack: error.stack ?? "",
    componentStack: "",
    url: window.location.href,
    userAgent: navigator.userAgent,
    timestamp: new Date().toISOString(),
    type: "unhandled-rejection"
  });
});

// Named so links back from the messaging app (target="velaro-admin") land in
// this exact tab instead of spawning a new one every time.
window.name = "velaro-admin";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement!);

loadClientConfig().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  reportWebVitals();
});
